module.exports = __webpack_public_path__ + "img/imgLogin.8876e82b.png";